import { render, staticRenderFns } from "./DesktopAppArray.vue?vue&type=template&id=8796acea&"
import script from "./DesktopAppArray.vue?vue&type=script&lang=js&"
export * from "./DesktopAppArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports